module.exports = __webpack_public_path__ + "img/r-red.2889b5e8.svg";